export default {
  Buy: 'Buy',
  Rent: 'Rent',
  Sell: 'Sell',
  Search: 'Search',
  title: 'Find your Dream Home',
  more: 'More',
  less: 'Less',
  userTrustedChoice: 'User Trusted Choice',
  servedUsers: '{num} user served',
  plentyOfHouses: 'Plenty of rooms for you to choose from',
  getHousesNumber: '{num} houses in the United States',
  beingSold: 'Featured Listings',
  beingRent: 'High End Properties For Rent',
  moreSelling: 'View More For Sale Properties',
  moreRenting: 'View More For Rent Properties',
  entireRent: 'Entire Unit',
  entire: 'Entire Unit',
  privateRoomRent: 'Private Room',
  masterBedroomRent: 'Master Bedroom',

  totalRating: 'Total Rating',
  location: 'Location',
  floorPlanGalleryAndRoomDetail: 'FloorPlanGallery And RoomDetail',
  roomDetail: 'Room Detail',
  insideFacility: 'Indoor Facility',
  moreInfo: 'More Info',
  builtYear: 'Built Year',
  showBuiltYear: 'Year Built {year}',
  showParking: '{num} parking',
  showStoreRoom: '{num} store room',
  heating: 'Heating',
  cooling: 'Cooling',
  decoration: 'House Style',
  genderRequired: 'Gender',
  allow: 'Allow',
  allowPet: 'Allow Pet',
  nopets: 'No Pets',
  orientation: 'Orientation',
  allowCooking: 'Allow Cooking',
  bondsman: 'Guarantor',
  floorType: 'Floor Type',
  elevator: 'Elevator',
  maxLiving: 'Max Living',
  partitionPanel: 'Partition Panel',
  minTenancyTerm: 'Min Tenancy Term',
  allowSmoking: 'Allow Smoking',
  allowParty: 'Allow Party',
  availableTime: 'Available Time',
  studio: 'Studio',

  female: 'Female',
  male: 'Male',
  notAllow: 'Not Allow',
  notNeed: 'Not Need',
  notExist: 'Not Exist',
  week: 'Week',
  east: 'East',
  west: 'West',
  north: 'North',
  south: 'South',
  southEast: 'SouthEast',
  northWest: 'NorthWest',
  northEast: 'NorthEast',
  southWest: 'SouthWest',
  locatedAt: 'Located at',
  viewAll: 'View All',
  collapse: 'Collapse',
  anytime: 'Anytime',
  propertyType: 'Property Type',
  wechat: 'WeChat',
  priceDetail: 'Price Detail',
  free: 'Free',
  rentPrice: 'Price',
  utilitiy: 'Utilitiy',
  utilitiyTrue: 'Free', // 包含水电费
  utilitiyFalse: 'Pay by Residents', // 不包含水电费
  applicationFee: 'Application Fee',
  hoaFee: 'HOA Fee',
  deposit: 'Deposit',
  noDeposit: 'No Deposit',
  garbageFee: 'Garbage Fee',
  parkingFee: 'Parking Fee',
  waterFee: 'Water Fee',
  tvFee: 'TV Fee',
  internetFee: 'Internet Fee',
  facilityFee: 'Facility Fee',
  utilityFee: 'Utility Fee',
  including: 'Including',
  selfCare: 'self-care',
  sqm: 'Sq.Ft',
  houseDetail: 'House Detail',
  feeDetails: 'Fee Details',
  school: 'School',
  transportation: 'Transportation',
  supermarket: 'Supermarket',
  floor: 'Floor',
  roof: 'Roof',
  totalPriceOfHouse: 'Listing Price',
  needLoan: 'Need Loan',
  fullPayment: 'Full Payment',
  monthlyExpenditure: 'Monthly expenditure',
  downPayment: 'Down Payment',
  floorPlanImage: 'Floor Plan Image',
  justUpdated: 'just updated',
  noData: 'No results, To get more results, try adjusting your search by changing your filters',
  hour: 'hour',
  day: 'day',
  updateBefore: 'Updated {num} {unit} ago',
  communityDetails: 'Community Details',
  localSay: "Let's see what the local residents say",
  dataFrom: 'All data are from the Jodi Group field survey',
  similarSellRecommendations: 'Similar recommendations for selling properties',
  sellingPrice: 'Listing Price',
  unitPrice: 'Unit price',
  selectAnAgent: 'Select An Agent',
  back: 'Back',
  scan: 'Scan to Add Friends',
  pets: {
    firendly: "Pets firendly",
    noPets: "No pets",
  },
  list: {
    entire: 'Entire',
  },

  filterBar: {
    more: 'More filters',
    less: 'Less',
    city: 'City',
    district: 'District',
    school: 'School',
    propertyType: 'Property Type',
    priceRange: 'Price Range',
    placeType: 'Place Type',
    houseType: 'House Type',
    elevator: 'Elevator',
    floor: 'Floor',
    inside: 'Inside Facilities',
    building: 'Building Facility',
    orientation: 'Orientation',
    decoration: 'Decoration',
    payPeriod: 'Pay Period',
    other: 'Other',
    feature: 'Feature',
    cooling: 'Cooling system',
    heating: 'Heating system',
    construction: 'Construction',
    roof: 'Roof',
    foundation: 'Foundation',
    familyType: 'Family Type',
    single: 'Single Family House',
    multi: 'Multi Family House'
  },
  notfound: {
    error: 'Page Not Found',
    tips: 'The page you visited was not found. The possible reason is that the address is invalid.',
    button: 'Back Home',
  },
  commentTitle: 'Any questions?',
  commentBtn: 'Submit',
  commentPlace: 'Ask Our Agent',
  comment: {
    success: 'Commenting Success',
    fail: 'Commenting Error',
  },
  bookView: 'Book to View',
  detailInfo: 'Detail Info',
  viewAllQA: 'View the other {num} questions',
  viewAlbum: 'View Album',
  noLimitPrice: 'Any',
  viewPicture: 'View Picture',
  whatThinkOf: 'What Do You Think Of This House? Rate It!',
  hasRated: "You've rated this house",
  submitRates: 'Submit',
  rates: 'Rates',
  agentRate: 'Rates',
  userRate: 'Clients Rates',
  hasQuestioned: 'Any more question please ask Our Agent',
  any: 'Any',
  decorationStyle: {
    simple: 'Simple And Clean Style',
    fancy: 'Luxury Style',
    european: 'Simple European Style',
  },
  loanLang: {
    interestRate: 'Interest Rate',
    mortgagePeriod: 'Mortgage Period',
    downPaymentRate: 'Down Payment Rate',
    years: 'years',
  },
  feeLang: {
    propertyTaxes: 'Property taxes',
    HOA: 'HOA',
    insurance: 'Insurance',
    mortgageInsurance: 'Mortgage insurance',
  },
  rentType: {
    entire: 'Entire Unit',
    masterBedroom: 'Master bedroom',
    secondaryBedroom: 'Secondary bedroom',
    privateRoom: 'Shared room'
  },
  houseType: {
    condo: 'Condo',
    home: 'Home',
    apartment: 'Apartment',
    townHouse: 'Town house',
    multiUnits: 'Multi-Units',
  },
  share: {
    title: 'This property need an access code to view details',
    errorTip: 'Password incorrect',
    placeholder: 'Enter your password for property details',
    confirm: 'Confirm'
  }
}
